import React from 'react';
import i18n from '../../../../i18n';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Select from 'react-select';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NoData from '../../../common/NoData';
import Dropdown from '../../../common/DropDown';
import {
  BanknoteArrowDown,
  Building2,
  Download,
  ExternalLink,
  FileMinus,
  FilePen,
  FileSpreadsheet,
  Gavel,
  MoveRight,
  Printer,
  SquarePause,
  WalletMinimal,
} from 'lucide-react';
import { getTransactions, getTransactionsSummary } from './services/transactionService';
import NewDropdown from '../../../common/NewDropDown';
import {
  exportBidderPaymentReport,
  exportClientPaymentReport,
  exportTransactionsReport,
  exportUserReport,
} from '../Transaction/service/transactionService';
import { formatDate } from '../../../../utils/common';
import { StatusNewBadge } from '../../../common/StatusBadge';
import { updateWallet } from '../../../../models/wallet';
import { toast } from 'react-toastify';
import { ActionModal } from './components/ActionModal';
import {
  getAuctionPaymentDetails,
  getBidders,
  getClientPayOutDetails,
  getClients,
} from '../CashFlowDashboard/services/cashFlowService';
import { getGroupList } from '../Group/services/groupServices';
import ProjectCard from '../../../common/ProjectCard';
import ProjectCardSkeleton from '../../../common/skelton/ProjectCardSkelton';
import { NavLink } from 'react-router-dom';
import { AmountCell } from '../CashFlowDashboard/CashFlowDashboard';
import {
  NEW_TRANSACTION_STATUS,
  TRANSACTION_METHODS,
  TRANSACTION_TYPES,
} from '../../../../constants/status';
import { imageUrl } from '../../../../constants/global';

const FILTER_CONFIG = {
  all: ['startDate', 'endDate', 'type', 'paymentMethod', 'client', 'group', 'bidder'],
  auction_due: ['startDate', 'endDate', 'client', 'group', 'bidder'],
  client_due: ['startDate', 'endDate', 'client', 'group', 'bidder'],
  hold: ['bidder'],
  balance: ['bidder'],
  withdrawal_requested: ['startDate', 'endDate', 'bidder'],
  withdrawal_completed: ['startDate', 'endDate', 'bidder'],
};

export class MzadcomWalletNew extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        type: '',
        method: '',
        client: null,
        group: null,
        bidder: null,
      },
      clients: [],
      groups: [],
      bidders: [],
      transactions: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
      actionLoadingId: null,
      showAction: false,
      selectedRow: null,
      selectedTab: 'all',
      summary: null,
      isSummaryLoading: false,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      type: params.get('type') || null,
      category: params.get('method') || null,
      client: params.get('client') ? parseInt(params.get('client')) : null,
      group: params.get('group') ? parseInt(params.get('group')) : null,
      bidder: params.get('bidder') ? parseInt(params.get('bidder')) : null,
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;
    const selectedTab = params.get('tab') || 'all';

    this.setState({ search, page, limit, selectedTab }, () => {
      this.fetchClientList();
      this.fetchGroupList();
      this.fetchBidderList();
      this.fetchSummary();
      this.fetchTransactions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async fetchTransactions() {
    this.setState({ isloading: true });

    const { limit, page, selectedTab } = this.state;
    const { startDate, endDate, type, method, client, group, bidder } = this.state.search;

    const q = {
      page,
      limit,
    };

    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (type) q.type = type;
    if (method) q.method = method;
    if (client) q.client = client;
    if (group) q.group = group;
    if (bidder) q.bidder = bidder;
    if (selectedTab) q.tab = selectedTab;

    this.updateUrlQuery(q);

    const apiMap = {
      auction_due: getAuctionPaymentDetails,
      client_due: getClientPayOutDetails,
      hold: getBidders,
      balance: getBidders,
      withdrawal_requested: getTransactions,
      withdrawal_completed: getTransactions,
      all: getTransactions,
    };

    const api = apiMap[selectedTab] || getTransactions;
    // Modify query based on selected tab
    switch (selectedTab) {
      case 'auction_due':
        q.status = 'bidder_pending';
        break;

      case 'client_due':
        q.status = 'client_pending';
        break;
      case 'hold':
        q.type = 'hold';
        q.pagination = true;
        break;

      case 'balance':
        q.type = 'balance';
        q.pagination = true;
        break;

      case 'withdrawal_requested':
        q.type = 'withdrawal_requested';
        break;

      case 'withdrawal_completed':
        q.type = 'withdraw';
        break;

      default:
        break;
    }

    try {
      const response = await api(q);

      if (response.success) {
        this.setState({
          transactions: response.data,
          total: response.meta.total,
        });
      }
    } catch (error) {
      console.error('Transaction fetch failed:', error);
    } finally {
      this.setState({ isloading: false });
    }
  }

  async fetchSummary() {
    this.setState({ isSummaryLoading: true });

    try {
      const { startDate, endDate, client, group, bidder } = this.state.search;

      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;
      if (client) q.client = client;
      if (group) q.group = group;
      if (bidder) q.bidder = bidder;

      const response = await getTransactionsSummary(q);

      if (response.success) {
        this.setState({
          summary: response.data,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isSummaryLoading: false });
    }
  }
  async fetchClientList() {
    this.setState({ clientLoading: true });

    try {
      const { startDate, endDate } = this.state.search;
      const { selectedTab } = this.state;

      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;

      if (selectedTab === 'auction_due') {
        q.type = 'auctionPayment';
        q.status = 'pending';
      }

      if (selectedTab === 'client_due') {
        q.type = 'clientPayment';
        q.status = 'pending';
      }

      const response = await getClients(q);

      if (response.success) {
        this.setState({
          clients: [
            {
              value: null,
              label: i18n.t('all') || 'All',
            },
            ...response.data.map((item) => ({
              value: item.id,
              label: item.organization_name,
            })),
          ],
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ clientLoading: false });
    }
  }

  async fetchGroupList() {
    this.setState({ groupLoading: true });

    try {
      const { startDate, endDate, client } = this.state.search;
      const { selectedTab } = this.state;

      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;
      if (client) q.organization = client;

      if (selectedTab === 'auction_due') {
        q.type = 'auctionPayment';
        q.status = 'pending';
      }

      if (selectedTab === 'client_due') {
        q.type = 'clientPayment';
        q.status = 'pending';
      }

      const response = await getGroupList(q);

      if (response.success) {
        this.setState({
          groups: [
            {
              value: null,
              label: i18n.t('all') || 'All',
              organization: null,
            },
            ...(response.data ?? []).map((item) => ({
              value: item.id,
              label: item.group_name,
              organization: item.organization,
            })),
          ],
        });
      }
    } catch (error) {
      console.error('Failed to fetch groups', error);
    } finally {
      this.setState({ groupLoading: false });
    }
  }
  async fetchBidderList() {
    this.setState({ bidderLoading: true });

    try {
      const { startDate, endDate, client, group } = this.state.search;
      const { selectedTab } = this.state;

      const q = {};
      if (client) q.client = client;
      if (group?.length) q.group = group.join(',');
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;

      if (selectedTab === 'auction_due') {
        q.type = 'auctionPayment';
        q.status = 'pending';
      }

      if (selectedTab === 'client_due') {
        q.type = 'clientPayment';
        q.status = 'pending';
      }

      if (selectedTab === 'hold') {
        q.type = 'hold';
      }

      if (selectedTab === 'balance') {
        q.type = 'balance';
      }

      if (selectedTab === 'withdrawal_requested') {
        q.type = 'withdrawal_requested';
      }

      if (selectedTab === 'withdrawal_completed') {
        q.type = 'withdrawal_completed';
      }

      const response = await getBidders(q);

      if (response.success) {
        const bidders = [
          {
            value: null,
            label: i18n.t('all') || 'All',
          },
          ...response.data.map((item) => ({
            value: item.id,
            label: `${item.name} (${item.id})`,
          })),
        ];
        this.setState({
          bidders,
          bidderLoading: false,
        });
      }
    } catch (error) {
      console.error('Failed to fetch bidders', error);
    } finally {
      this.setState({ bidderLoading: false });
    }
  }
  async updateWalletRow(status, row) {
    try {
      this.setState({ actionLoadingId: row.id });

      let payload = {
        status: status,
        id: row.id,
        user: row.user,
      };

      const response = await updateWallet(payload, row.id);

      if (response && response.success) {
        toast.success(i18n.t('approved'));
        this.handleSearch();
      } else {
        toast.error(i18n.t('something_went_wrong'));
      }
    } catch (error) {
      toast.error(i18n.t('something_went_wrong'));
    } finally {
      this.setState({ actionLoadingId: null });
    }
  }

  handleActions = (row) => {
    this.setState({
      showAction: true,
      selectedRow: row,
    });
  };
  getColumns = () => {
    const { selectedTab } = this.state;

    const columnMap = {
      all: this.getAllColumns,
      auction_due: this.getAuctinColumns,
      client_due: this.getClientColumns,
      hold: this.getUserColumns,
      balance: this.getBalanceColumns,
      withdrawal_request: this.getAllColumns,
      withdrawal_completed: this.getAllColumns,
    };

    return (columnMap[selectedTab] || columnMap.all).call(this);
  };
  getAllColumns = () => {
    const { selectedTab } = this.state;
    const { type } = this.state.search;
    // const isAdmin = user?.role === 'A';
    // const isFinance = user?.role === 'F';
    const hideGroupColumns =
      ['withdrawal_requested', 'withdrawal_completed'].includes(selectedTab) ||
      ['recharge', 'withdraw'].includes(type);

    const columns = [
      {
        name: 'Sl No',
        width: '90px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: i18n.t('id'),
        wrap: true,
        sortable: true,
        width: '80px',
        cell: (row) => {
          const enrollUrl = row.group_id
            ? `/enrolled_users?group=${row.group_id}`
            : '/enrolled_users';

          const showEnrollLink =
            row.type === 'enroll' ||
            row.type === 'client_payment' ||
            (row.type === 'withdraw' && row.status === 'A');

          return (
            <div className="table-row-info">
              <span className="highlight-table-value">{row.id}</span>

              {showEnrollLink && (
                <a
                  href={enrollUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="table-row-info__wallet"
                >
                  {i18n.t('enroll')}
                  <ExternalLink size={13} />
                </a>
              )}
            </div>
          );
        },
      },
    ];
    if (!hideGroupColumns) {
      columns.push(
        {
          name: i18n.t('group'),
          minWidth: '140px',
          cell: (row) => (
            <span className="highlight-table-value-secondary">
              {row.group ? `${row.group?.group_name} (${row.group?.id})` : ' -- '}
            </span>
          ),
        },
        {
          name: i18n.t('auction'),
          minWidth: '160px',
          cell: (row) => (
            <span className="highlight-table-value-secondary">
              {row.auction_relation
                ? `${row.auction_relation?.title} (${row.auction_relation?.id})`
                : ' -- '}
            </span>
          ),
        }
      );
    }
    columns.push(
      {
        name: i18n.t('bidder_id'),
        minWidth: '90px',
        cell: (row) => <span className="highlight-table-value"> {row.user}</span>,
      },
      {
        name: i18n.t('name'),
        width: '100px',
        cell: (row) => <span className="highlight-table-value">{row?.user_relation?.name}</span>,
        wrap: true,
      },
      {
        name: i18n.t('username'),
        width: '100px',
        cell: (row) => <span>{row?.user_relation?.username}</span>,
        wrap: true,
      },
      {
        name: i18n.t('email'),
        width: '120px',
        cell: (row) => <span>{row?.user_relation?.email}</span>,
        wrap: true,
      },
      {
        name: i18n.t('transaction'),
        minWidth: '140px',
        cell: (row) => <span>{row.transaction_id}</span>,
      },
      {
        name: i18n.t('credit'),
        minWidth: '100px',
        right: true,
        cell: (row) => <span className="highlight-table-value-secondary">{row.credit}</span>,
      },
      {
        name: i18n.t('debit'),
        minWidth: '100px',
        right: true,
        cell: (row) => <span className="highlight-table-value-secondary">{row.debit}</span>,
      },
      {
        name: i18n.t('hold'),
        minWidth: '100px',
        right: true,
        cell: (row) => <span className="highlight-table-value-secondary">{row.hold_amount}</span>,
      },
      {
        name: i18n.t('balance'),
        minWidth: '100px',
        right: true,
        cell: (row) => <span className="highlight-table-value-secondary">{row.balance}</span>,
      },
      {
        name: i18n.t('client_amount'),
        minWidth: '120px',
        right: true,
        cell: (row) => <span className="highlight-table-value-secondary">{row.client_amount}</span>,
      },
      {
        name: i18n.t('ref'),
        minWidth: '180px',
        cell: (row) => <span>{row.reference}</span>,
      },
      {
        name: i18n.t('type'),
        minWidth: '100px',
        cell: (row) => <span>{TRANSACTION_TYPES[row.type]?.text || row.type || '-'}</span>,
      },
      {
        name: i18n.t('method'),
        minWidth: '100px',
        cell: (row) => <StatusNewBadge status={TRANSACTION_METHODS[row.method]} />,
      },
      {
        minWidth: '190px',
        name: i18n.t('status'),
        cell: (row) => <StatusNewBadge status={NEW_TRANSACTION_STATUS[row.status]} />,
        wrap: true,
      },
      {
        name: i18n.t('admin_aprroved'),
        minWidth: '150px',
        cell: (row) =>
          row.admin_approved_on ? (
            <span className="highlight-table-value-secondary">
              {formatDate(row.admin_approved_on)}
            </span>
          ) : (
            <span className="attachment-empty">No Data</span>
          ),
      },
      {
        name: i18n.t('finance_aprroved'),
        minWidth: '150px',
        cell: (row) =>
          row.fm_approved_on ? (
            <span className="highlight-table-value-secondary">
              {formatDate(row.fm_approved_on)}
            </span>
          ) : (
            <span className="attachment-empty">No Data</span>
          ),
      },
      {
        name: i18n.t('date'),
        minWidth: '120px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">{formatDate(row.created_at)}</span>
        ),
      },
      {
        name: i18n.t('receipt'),
        width: '130px',
        wrap: true,
        cell: (row) => {
          const receiptPath = row.file_receipt
            ? `uploads/wallet/receipt/${row.file_receipt}`
            : row.enroll_receipt
              ? `uploads/enrolls/receipt/${row.enroll_receipt}`
              : null;

          return receiptPath ? (
            <a
              className="button-table"
              href={`${imageUrl}${receiptPath}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FileSpreadsheet size={18} /> {i18n.t('receipt')}
            </a>
          ) : (
            <span className="attachment-empty">{i18n.t('no_receipt')}</span>
          );
        },
      },
      {
        name: i18n.t('attachment'),
        width: '150px',
        cell: (row) => {
          const paymentReceipts = row.payment_receipts || [];
          const attachmentReceipts = row.attachment_receipts || [];

          return (
            <div className="attachment-list">
              {/* Main Receipt */}
              {row.file_fm && (
                <a
                  href={`${imageUrl}uploads/wallet/receipt/${row.file_fm}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="attachment-link receipt"
                >
                  {i18n.t('receipt')}
                </a>
              )}

              {/* Payment Receipts */}
              {paymentReceipts.map((item, index) => (
                <a
                  key={`payment-${index}`}
                  href={`${imageUrl}uploads/wallet/receipt/${item.receipt_url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="attachment-link payment"
                >
                  {i18n.t('payment-receipt')} {index + 1}
                </a>
              ))}

              {/* Attachment Receipts */}
              {attachmentReceipts.map((item, index) => (
                <a
                  key={`attachment-${index}`}
                  href={`${imageUrl}uploads/wallet/receipt/${item.document}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="attachment-link document"
                >
                  {i18n.t('document')} {index + 1}
                </a>
              ))}

              {/* Empty State */}
              {!row.file_fm && paymentReceipts.length === 0 && attachmentReceipts.length === 0 && (
                <span className="attachment-empty">No Attachment</span>
              )}
            </div>
          );
        },
      }
    );
    return columns;
  };
  getAuctinColumns = () => {
    return [
      {
        id: 1,
        name: i18n.t('sl'),
        width: '70px',
        sortable: false,
        center: true,
        cell: (row, index) => (this.state.page - 1) * this.state.limit + index + 1,
      },
      {
        name: i18n.t('client_name'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">{row.organization?.name || '-'}</span>
        ),
      },
      {
        name: i18n.t('auction_id'),
        width: '130px',
        sortable: true,
        cell: (row) => <span> {row.auction_id}</span>,
      },
      {
        name: i18n.t('auction_name'),
        minWidth: '140px',
        cell: (row) => `${row.title}`,
      },
      {
        name: i18n.t('group_name'),
        minWidth: '140px',
        cell: (row) => row?.group?.name,
        wrap: true,
      },
      {
        name: i18n.t('bidder_id'),
        width: '110px',
        sortable: true,
        cell: (row) => <span className="user-id">{row?.winner?.id}</span>,
      },
      {
        name: i18n.t('bidder_name'),
        width: '140px',
        sortable: true,
        cell: (row) => <span>{row?.winner?.name}</span>,
      },
      {
        name: i18n.t('email'),
        minWidth: '130px',
        cell: (row) => row?.winner?.email,
        wrap: true,
      },

      {
        name: i18n.t('total_payable'),
        width: '140px',
        right: true,
        cell: (row) => row?.financials?.total_amount,
      },
      {
        name: i18n.t('bidder_paid'),
        width: '140px',
        right: true,
        cell: (row) => row?.financials?.paid,
      },
      {
        name: i18n.t('payable_balance'),
        width: '150px',
        right: true,
        cell: (row) => <span className="highlight-table-value">{row?.financials?.balance}</span>,
      },

      {
        name: i18n.t('due_date'),
        width: '120px',
        cell: (row) => row.approved_date || '-',
      },
      {
        name: i18n.t('due_days'),
        width: '120px',
        cell: (row) => {
          if (!row.approved_date) return '-';

          const dueDate = new Date(row.approved_date);
          const today = new Date();

          const diffTime = dueDate.getTime() - today.getTime();

          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          const isOverdue = diffDays < 0;

          const displayText = isOverdue
            ? `${Math.abs(diffDays)} days overdue`
            : `${diffDays} days left`;

          return (
            <span className={`highlight-table-value ${isOverdue ? 'overdue' : 'upcoming'}`}>
              {displayText}
            </span>
          );
        },
      },
    ];
  };

  getClientColumns = () => {
    const { search } = this.state;
    return [
      {
        name: i18n.t('sl'),
        center: true,
        sortable: false,

        cell: (row, index) => <span className="sl-number">{index + 1}</span>,
      },
      {
        name: i18n.t('client'),
        sortable: false,
        cell: (row) => (
          <span className="remark-text">
            {row?.organization?.name} ({row?.organization?.id})
          </span>
        ),
      },
      {
        name: i18n.t('total_client_amount'),
        right: true,
        sortable: false,
        cell: (row) => (
          <AmountCell
            amount={row?.total_client_amount?.amount}
            count={row?.total_client_amount?.auction_count}
            color="#1b8f9b"
          />
        ),
      },
      {
        name: i18n.t('client_amount_paid'),
        right: true,
        sortable: false,
        cell: (row) => (
          <AmountCell
            amount={row?.paid_client_amount?.amount}
            count={row?.paid_client_amount?.auction_count}
            color="#10b981"
          />
        ),
      },
      {
        name: i18n.t('pending_client_due'),
        right: true,
        sortable: false,
        cell: (row) => (
          <AmountCell
            amount={row?.pending_client_amount?.amount}
            count={row?.pending_client_amount?.auction_count}
            color="#ef4444"
          />
        ),
      },
      {
        name: i18n.t('action'),
        right: true,

        cell: (row) => (
          <NavLink
            to={{
              pathname: '/cash-flow/auction-payment/client/details',

              search: new URLSearchParams(
                Object.fromEntries(
                  Object.entries({
                    startDate: search?.startDate,
                    endDate: search?.endDate,
                    bidder: search?.bidder,
                    group: search?.group?.length ? search.group.join(',') : null,

                    // CLIENT ID FROM ROW
                    client: row?.organization?.id,

                    status: 'client_pending',
                  }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                )
              ).toString(),
            }}
            className="details-link"
          >
            {i18n.t('details')}
            <span className="arrow">
              <MoveRight strokeWidth={1} />
            </span>
          </NavLink>
        ),
      },
    ];
  };
  getBalanceColumns = () => {
    const { selectedTab } = this.state;

    const baseColumns = [
      {
        name: i18n.t('sl'),
        center: true,
        sortable: false,
        cell: (row, index) => <span className="sl-number">{index + 1}</span>,
      },
      {
        name: i18n.t('bidder_id'),
        selector: (row) => row.id,
        cell: (row) => <span className="highlight-table-value">{row.id}</span>,
      },
      {
        name: i18n.t('name'),
        cell: (row) => <span className="highlight-table-value">{row.name}</span>,
        wrap: true,
      },
      {
        name: i18n.t('username'),
        cell: (row) => <span>{row.username}</span>,
        wrap: true,
      },
      {
        name: i18n.t('email'),
        cell: (row) => <span>{row.email}</span>,
        wrap: true,
      },
    ];

    //  dynamic column based on selectedTab
    if (selectedTab === 'hold') {
      baseColumns.push({
        name: i18n.t('hold'),
        cell: (row) => <span>{row.hold_amount}</span>,
        wrap: true,
      });
    }

    if (selectedTab === 'balance') {
      baseColumns.push({
        name: i18n.t('balance'),
        cell: (row) => <span>{row.wallet_amount}</span>,
        wrap: true,
      });
    }

    return baseColumns;
  };
  getUserColumns = () => {
    const { selectedTab } = this.state;

    const baseColumns = [
      {
        name: i18n.t('sl'),
        center: true,
        sortable: false,
        cell: (row, index) => <span className="sl-number">{index + 1}</span>,
      },
      {
        name: i18n.t('bidder_id'),
        selector: (row) => row.id,
        cell: (row) => <span className="highlight-table-value">{row.id}</span>,
      },
      {
        name: i18n.t('name'),
        cell: (row) => <span className="highlight-table-value">{row.name}</span>,
        wrap: true,
      },
      {
        name: i18n.t('username'),
        cell: (row) => <span>{row.username}</span>,
        wrap: true,
      },
      {
        name: i18n.t('email'),
        cell: (row) => <span>{row.email}</span>,
        wrap: true,
      },
    ];

    //  dynamic column based on selectedTab
    if (selectedTab === 'hold') {
      baseColumns.push({
        name: i18n.t('hold'),
        cell: (row) => <span>{row.hold_amount}</span>,
        wrap: true,
      });
    }

    if (selectedTab === 'balance') {
      baseColumns.push({
        name: i18n.t('balance'),
        cell: (row) => <span>{row.wallet_amount}</span>,
        wrap: true,
      });
    }

    return baseColumns;
  };
  //  Client onChange — store as integer, clear groups, load group list
  handleClientChange = (selectedOption) => {
    const clientValue = selectedOption ? parseInt(selectedOption.value) : null;
    this.setState(
      (prevState) => ({
        search: {
          ...prevState.search,
          client: clientValue,
          group: null,
          bidder: null,
        },
        groups: [],
        bidders: [],
      }),
      async () => {
        await this.fetchGroupList();
        await this.fetchBidderList();
      }
    );
  };

  //  Group onChange — store as integer
  handleGroupChange = (selectedOption) => {
    const groupValue = selectedOption ? parseInt(selectedOption.value) : null;
    const clientValue = selectedOption?.organization || null;

    this.setState(
      (prevState) => ({
        search: {
          ...prevState.search,
          client: clientValue,
          group: groupValue,
          bidder: null,
        },
      }),
      async () => {
        await this.fetchBidderList();
      }
    );
  };

  //  Bidder onChange — store as integer
  handleBidderChange = (selectedOption) => {
    this.setState((prevState) => ({
      search: {
        ...prevState.search,
        bidder: selectedOption ? parseInt(selectedOption.value) : null,
      },
    }));
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          // Only load if client has value
          this.fetchGroupList();
        }
      }
    );
  };

  handleSearch = () => {
    this.fetchSummary();
    this.fetchTransactions();
  };

  handleClear = () => {
    const defaultSearch = {
      startDate: null,
      endDate: null,
      type: '',
      method: '',
      client: null,
      group: null,
      bidder: null,
    };

    this.setState({ search: defaultSearch, page: 1, selectedTab: 'all', selectedRows: [] }, () => {
      this.fetchSummary();
      this.fetchTransactions();
    });
  };

  handleDownload = async (fileType) => {
    const { search, selectedTab } = this.state;

    const params = {
      ...Object.fromEntries(
        Object.entries(search).filter(([_, value]) => value !== null && value !== '')
      ),
      fileType,
    };

    let exportApi = exportTransactionsReport;
    let fileName = 'Transaction_Report';

    switch (selectedTab) {
      case 'auction_due':
        exportApi = exportBidderPaymentReport;
        fileName = 'Bidder_Payment_Report';
        params.status = 'bidder_pending';
        break;

      case 'client_due':
        exportApi = exportClientPaymentReport;
        fileName = 'Client_Payment_Report';
        break;

      case 'hold':
        exportApi = exportUserReport;
        params.type = 'hold';
        fileName = 'Hold_Report';
        break;

      case 'balance':
        exportApi = exportUserReport;
        params.type = 'balance';
        fileName = 'Balance_Report';
        break;

      case 'withdrawal_requested':
        exportApi = exportTransactionsReport;
        params.type = 'withdrawal_requested';
        fileName = 'Withdrawal_Requested_Report';
        break;

      case 'withdrawal_completed':
        exportApi = exportTransactionsReport;
        params.type = 'withdraw';
        fileName = 'Withdrawal_Completed_Report';
        break;

      default:
        exportApi = exportTransactionsReport;
        fileName = 'Transaction_Report';
        break;
    }

    this.setState({ exportLoading: true });

    try {
      await exportApi({
        params,
        fileType,
        fileName,
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.fetchTransactions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.fetchTransactions();
    });
  };
  isFilterVisible = (filter) => {
    const { selectedTab } = this.state;

    return (FILTER_CONFIG[selectedTab] || FILTER_CONFIG.all).includes(filter);
  };

  handleCardClick = (tab) => {
    const visible = FILTER_CONFIG[tab];

    this.setState(
      (prevState) => ({
        selectedTab: tab,
        search: {
          ...prevState.search,
          type: visible.includes('type') ? prevState.search.type : null,
          paymentMethod: visible.includes('paymentMethod') ? prevState.search.paymentMethod : null,
          client: visible.includes('client') ? prevState.search.client : null,
          group: visible.includes('group') ? prevState.search.group : [],
          bidder: visible.includes('bidder') ? prevState.search.bidder : null,
        },
        page: 1,
      }),
      () => {
        this.fetchTransactions();
      }
    );
  };

  render() {
    const {
      clients,
      clientLoading,
      groups,
      groupLoading,
      bidders,
      bidderLoading,
      transactions,
      isloading,
      exportLoading,
      showAction,
      selectedRow,
      summary,
    } = this.state;

    const { startDate, endDate } = this.state.search;
    const summaryCards = [
      {
        id: 'auction_due',
        title: i18n.t('bidder_due'),
        amount: summary?.bidder_payment_due?.amount || 0,
        value: summary?.bidder_payment_due?.count || 0,
        valueLabel: i18n.t('auctions'),
        icon: Gavel,
        className: 'Pending',
      },
      {
        id: 'client_due',
        title: i18n.t('client_due'),
        amount: summary?.client_payment_due?.client_amount || 0,
        value: summary?.client_payment_due?.client_count || 0,
        valueLabel: i18n.t('clients'),
        icon: Building2,
        className: 'FundAdded',
      },
      {
        id: 'hold',
        title: i18n.t('hold'),
        amount: summary?.hold?.amount || 0,
        value: summary?.hold?.count || 0,
        valueLabel: i18n.t('bidders'),
        icon: SquarePause,
        className: 'Rejected',
      },
      {
        id: 'balance',
        title: i18n.t('balance_available'),
        amount: summary?.balance?.amount || 0,
        value: summary?.balance?.count || 0,
        valueLabel: i18n.t('bidders'),
        icon: WalletMinimal,
        className: 'Approved',
      },
      {
        id: 'withdrawal_requested',
        title: i18n.t('withdrawal_requested'),
        amount: summary?.withdrawal_requested?.amount || 0,
        value: summary?.withdrawal_requested?.count || 0,
        valueLabel: i18n.t('transactions'),
        icon: FilePen,
        className: 'FinanceSettled',
      },
      {
        id: 'withdrawal_completed',
        title: i18n.t('withdrawal_completed'),
        amount: summary?.withdrawal_completed?.amount || 0,
        value: summary?.withdrawal_completed?.count || 0,
        valueLabel: i18n.t('transactions'),
        icon: BanknoteArrowDown,
        className: 'LoadingCompleted',
      },
    ];

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('transactions')}
          subtitle={i18n.t('manage_transactions_bidders_and_financial_records')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">
                      <NewDropdown
                        label={i18n.t('export')}
                        loading={exportLoading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('excel'),
                            icon: FileSpreadsheet,
                            onClick: () => this.handleDownload('excel'),
                          },
                          {
                            label: i18n.t('pdf'),
                            icon: Printer,
                            disabled: true,
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="transaction-summary">
                      <div className="transaction-summary__header">
                        <div
                          className="transaction-summary__link"
                          onClick={() => this.handleCardClick('all')}
                        >
                          All Transactions
                        </div>
                      </div>
                      <div className="transaction-summary__content">
                        {this.state.isSummaryLoading
                          ? [...Array(6)].map((_, idx) => <ProjectCardSkeleton key={idx} />)
                          : summaryCards.map((item, idx) => {
                              const Icon = item.icon;

                              return (
                                <ProjectCard
                                  key={item.id}
                                  className={item.className}
                                  icon={Icon}
                                  title={item.title}
                                  amount={item.amount}
                                  value={item.value}
                                  valueLabel={item.valueLabel}
                                  selected={this.state.selectedTab === item.id}
                                  onClick={() => this.handleCardClick(item.id)}
                                />
                              );
                            })}
                      </div>
                    </div>

                    <FilterSection
                      loading={this.state.isloading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Start Date */}
                      {this.isFilterVisible('startDate') && (
                        <div className="select-wrapper floating-label-wrapper">
                          <input
                            id="startDate"
                            type="date"
                            name="startDate"
                            value={startDate || ''}
                            onChange={this.handleSearchChange}
                            className="filter-base floating-input"
                            placeholder=" " // Important: single space for floating effect
                          />
                          <label htmlFor="startDate" className="floating-label">
                            {i18n.t('start_date')}
                          </label>
                        </div>
                      )}

                      {/* End Date */}
                      {this.isFilterVisible('endDate') && (
                        <div className="select-wrapper floating-label-wrapper">
                          <input
                            id="endDate"
                            type="date"
                            name="endDate"
                            value={endDate || ''}
                            onChange={this.handleSearchChange}
                            className="filter-base floating-input"
                            placeholder={i18n.t('end_date')}
                          />
                          <label htmlFor="endDate" className="floating-label">
                            {i18n.t('end_date')}
                          </label>
                        </div>
                      )}

                      {/* Type  Dropdown */}
                      {this.isFilterVisible('type') && (
                        <Dropdown
                          name="type"
                          value={this.state.search.type}
                          onChange={this.handleSearchChange}
                          placeholder={i18n.t('type')}
                          empty={i18n.t('select_type')}
                          options={[
                            { value: 'recharge', label: i18n.t('recharge') },
                            { value: 'withdraw', label: i18n.t('withdrawal') },
                            { value: 'enrollment', label: i18n.t('hold') },
                            { value: 'refund', label: i18n.t('refund') },
                            { value: 'client_payment', label: i18n.t('auction_payment_s') },
                            { value: 'client_withdraw', label: i18n.t('client_withdraw') },
                            { value: 'client_remittance', label: i18n.t('client_remittance') },
                          ]}
                        />
                      )}

                      {/* Category Type Dropdown */}
                      {this.isFilterVisible('paymentMethod') && (
                        <Dropdown
                          name="method"
                          value={this.state.search.method}
                          onChange={this.handleSearchChange}
                          placeholder={i18n.t('payment_method')}
                          empty={i18n.t('select_method')}
                          options={[
                            { value: 'online', label: i18n.t('online') },
                            { value: 'offline', label: i18n.t('offline') },
                            { value: 'wallet', label: i18n.t('wallet') },
                          ]}
                        />
                      )}

                      {/* Client Dropdown */}
                      {this.isFilterVisible('client') && (
                        <div className="react-select-wrapper">
                          <Select
                            options={clients}
                            value={
                              clients.find((c) => c.value === this.state.search.client) || null
                            }
                            onChange={this.handleClientChange}
                            name="client"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={clientLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
                            isLoading={clientLoading}
                            isDisabled={clientLoading}
                            isClearable
                          />
                          <label className="react-select-label">
                            {i18n.t('client') || 'Client'}
                          </label>
                        </div>
                      )}

                      {/* Group Dropdown */}
                      {this.isFilterVisible('group') && (
                        <div className="react-select-wrapper">
                          <Select
                            options={groups}
                            //  compare number === number
                            value={groups.find((c) => c.value === this.state.search.group) || null}
                            onChange={this.handleGroupChange}
                            name="group"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={groupLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
                            isLoading={groupLoading}
                            isDisabled={groupLoading}
                            isClearable
                          />
                          <label className="react-select-label">{i18n.t('group_name')}</label>
                        </div>
                      )}

                      {/* Bidder Dropdown */}
                      {this.isFilterVisible('bidder') && (
                        <div className="react-select-wrapper">
                          <Select
                            options={bidders}
                            value={
                              bidders.find((c) => c.value === this.state.search.bidder) || null
                            }
                            onChange={this.handleBidderChange}
                            name="bidder"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={bidderLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
                            isLoading={bidderLoading}
                            isDisabled={bidderLoading}
                            isClearable
                          />
                          <label className="react-select-label">{i18n.t('bidder')}</label>
                        </div>
                      )}
                    </FilterSection>

                    <div className="Data-Listing">
                      {isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : transactions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={transactions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                          expandableRows={this.state.selectedTab === 'hold'}
                          expandableRowsComponent={({ data }) => (
                            <EnrollmentNotRefundedTable data={data.enrollments} />
                          )}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_transactions_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.fetchTransactions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ActionModal
          show={showAction}
          selectedTransaction={selectedRow}
          onClose={() =>
            this.setState({
              showAction: false,
              selectedRow: null,
            })
          }
          onComplete={() => {
            this.fetchTransactions();
            this.setState({ showAction: false, selectedRow: null });
          }}
        />
      </React.Fragment>
    );
  }
}

const EnrollmentNotRefundedTable = ({ data }) => {
  console.log(data, 'enroll');

  if (!data || data.length === 0) {
    return (
      <div className="no-bidders">
        <div className="no-bidders-content">
          <span className="no-bidders-icon">
            <FileMinus />
          </span>
          <span>No Enrollment available</span>
        </div>
      </div>
    );
  }

  return (
    <div className="receipts-wrapper">
      <div className="receipts-header">
        <h6>Enrollment Information</h6>
        <span className="receipts-count">
          {data.length} Receipt{data.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="receipts-table-container">
        <table className="receipts-table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Group</th>
              <th>Auction</th>
              <th>Credit</th>
              <th>Debit</th>
              <th>Refernce</th>
              <th>Type</th>
              <th>Method</th>
              <th>Receipt</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {data.map((enrollment) => (
              <tr key={enrollment.id}>
                <td className="receipts-email">{enrollment.id}</td>
                <td className="receipts-email">
                  {enrollment.group
                    ? `${enrollment.group?.group_name} (${enrollment.group?.id})`
                    : ' -- '}
                </td>
                <td className="receipts-number">
                  {enrollment.auction_relation
                    ? `${enrollment.auction_relation?.title} (${enrollment.auction_relation?.id})`
                    : ' -- '}
                </td>
                <td className="receipts-number">{enrollment.credit}</td>
                <td className="receipts-number">
                  <strong>{enrollment.debit}</strong>
                </td>
                <td className="receipts-number">{enrollment.reference}</td>
                <td className="receipts-number">
                  {TRANSACTION_TYPES[enrollment.type]?.text || enrollment.type || '-'}
                </td>
                <td className="receipts-number">
                  <StatusNewBadge status={TRANSACTION_METHODS[enrollment.method]} />
                </td>
                <td className="receipts-number">
                  {(() => {
                    const receiptPath = enrollment.file_receipt
                      ? `uploads/wallet/receipt/${enrollment.file_receipt}`
                      : enrollment.enroll_receipt
                        ? `uploads/enrolls/receipt/${enrollment.enroll_receipt}`
                        : null;

                    return receiptPath ? (
                      <a
                        className="button-table"
                        href={`${imageUrl}${receiptPath}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FileSpreadsheet size={18} /> {i18n.t('receipt')}
                      </a>
                    ) : (
                      <span className="attachment-empty">{i18n.t('no_receipt')}</span>
                    );
                  })()}
                </td>
                <td className="receipts-number">
                  <StatusNewBadge status={NEW_TRANSACTION_STATUS[enrollment.status]} />
                </td>
                <td className="receipts-number">{formatDate(enrollment.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
